export const firebaseConfig = {
    apiKey: "AIzaSyAF4ON6ql_sMgpOJ17ZF9obkLiIqLLiiEw",
    authDomain: "efectivo-digital.firebaseapp.com",
    projectId: "efectivo-digital",
    storageBucket: "efectivo-digital.appspot.com",
    messagingSenderId: "394225840157",
    appId: "1:394225840157:web:794a1a265e4fa98ddb96f4",
    measurementId: "G-6FKRVD53VQ",
    vapidKey:"BFVl0lHti6HQMLQ_k9mzve-MrHo5Y73r2NTVaqrMnnz3m6j_WoIZP2MYMi7PdrnfHDhHoKvftX2sHe6p6bamF7g"
}